import React from 'react';
import {CircularProgress, Dialog, DialogTitle, Typography} from '@material-ui/core';
import PropTypes from 'prop-types';

const Progress = ({size = 20, title = '', replaceAllText = false}) => (
  <Dialog open={true}>
    <DialogTitle id="simple-dialog-title">
      <CircularProgress size={size} style={{marginBottom: -5, marginRight: 15}} />
      <Typography variant="overline">{replaceAllText ? `${title}... ` : `Loading ${title}... `}</Typography>
    </DialogTitle>
  </Dialog>
);

Progress.propTypes = {
  replaceAllText: PropTypes.bool,
  size: PropTypes.number,
  title: PropTypes.string,
};

export default Progress;
